<template>
  <section>
    <div class="box has-text-centered" v-if="isLoading">
      <loading-spin></loading-spin>
    </div>

    <div v-else class="box mb-4" v-for="(cert, index) of certs" :key="index">
      <template>
        <div class="is-flex is-flex-direction-row is-align-items-center mb-1">
          <div class="is-flex is-flex-direction-column is-flex-grow-1">
            <h6 v-if="cert.estado === 'pendiente'" class="title is-6 mb-2 is-italic">Solicitud</h6>
            <div class="is-flex is-flex-direction-row">
              <span class="is-size-6 is-400">
                <span class="is-size-6 is-500">Usuario:</span> {{ cert.usuario.nombre }} {{ cert.usuario.apellido }}
              </span>&nbsp;-&nbsp;
              <span class="is-size-6 is-400">
                <span class="is-size-6 is-500">CUIL:</span> {{ cert.usuario.cuil }}
              </span>
            </div>
            <span class="is-size-6 is-400" v-if="tieneRolLyris">
              <span class="is-size-6 is-500 disabled">Id de la organización: {{ cert.usuario.organizacion_id }}</span>
            </span>
          </div>
          <b-tag rounded type="is-warning is-light" size="is-medium" class="is-500"
            v-if="cert.estado === 'pendiente'">Pendiente</b-tag>
          <b-tag rounded type="is-success is-light" size="is-medium" class="is-500"
            v-if="cert.estado === 'aprobado'">Aprobado</b-tag>
            <b-tag rounded type="is-success is-light" size="is-medium" class="is-500"
            v-if="cert.estado === 'vigente'">Vigente</b-tag>
          <b-tag rounded type="is-danger is-light" size="is-medium" class="is-500"
            v-if="cert.estado === 'revocado'">Revocado</b-tag>
          <b-tag rounded type="is-danger is-light" size="is-medium" class="is-500"
            v-if="cert.estado === 'rechazado'">Rechazado</b-tag>
          <b-tag rounded type="is-light" size="is-medium" class="is-500"
            v-if="cert.estado === 'vencido'">Vencido</b-tag>
        </div>

        <div class="is-flex is-flex-direction-row is-align-items-center py-2"
          v-if="cert.estado === 'vigente' || cert.estado === 'pendiente'">
          <router-link v-if="cert.estado === 'pendiente' && enabledOr" class="button is-success is-outlined mr-4"
            :to="({ name: 'certificadoAprobacion', params: { idCert: cert.id }})">
            <i class="fas fa-check"></i>&nbsp;&nbsp;Aprobar
          </router-link>
          <router-link v-if="cert.estado === 'pendiente' && enabledOr" class="button is-danger is-outlined"
            :to="({ name: 'certificadoRechazo', params: { idCert: cert.id }})">
            <i class="fas fa-times"></i>&nbsp;&nbsp;Rechazar
          </router-link>
          <router-link v-if="cert.estado === 'vigente' && enabledOr" class="button is-danger is-outlined mr-4"
            :to="({ name: 'certificadosRevocacion', params: { idCert: cert.id }, query: { fromOR: true }})">
            <i class="fas fa-times"></i>&nbsp;&nbsp;Revocar
          </router-link>
          <b-button v-if="cert.estado === 'vigente'" class="is-primary is-outlined"
            @click="downloadActaAlta(cert.documento_alta_id)">
            <i class="fas fa-download"></i>&nbsp;&nbsp;Descargar acta de alta
          </b-button>
        </div>

        <div class="is-flex is-flex-direction-column">
          <span v-if="cert.estado === 'rechazado' && cert.comentario" class="is-size-6 is-400 mb-1">
            <span class="is-500">Motivo de rechazo:</span> {{ cert.comentario }}
          </span>
          <span v-if="cert.estado === 'pendiente' || cert.estado === 'rechazado'" class="mt-1">
            <span class="is-500">Fecha de solicitud:</span> {{ dateFormat(cert.created_at) }}
          </span>
          <span v-if="cert.estado !== 'pendiente' && cert.estado !== 'rechazado'">
            <span class="is-500">Fecha de emisión:</span> {{ dateFormat(cert.fecha_emision) }}
          </span>
          <span v-if="cert.estado !== 'pendiente' && cert.estado !== 'rechazado'" class="mt-1">
            <span class="is-500">Fecha de vencimiento:</span> {{ dateFormat(cert.fecha_vencimiento) }}
          </span>
          <span v-if="cert.estado === 'revocado'" class="mt-1">
            <span class="is-500">Fecha de revocación:</span> {{ dateFormat(cert.fecha_revocacion) }}
          </span>
            <span v-if="cert.estado === 'revocado'" class="mt-1">
            <span class="is-500">Motivo de revocación:</span> {{ reasonString(cert.razon_revocacion.toLowerCase()) }}
          </span>
          <span v-if="cert.estado === 'revocado' && cert.comentario" class="mt-1">
            <span class="is-500">Comentario adicional:</span> {{ cert.comentario }}
          </span>
          <span v-if="cert.estado !== 'pendiente' && cert.estado !== 'rechazado'" class="is-size-6 is-400 mt-1">
            <span class="is-500">Número de serie:</span> {{ cert.numero_serie }}
          </span>
        </div>
      </template>
    </div>

    <div class="box has-text-centered" v-if="certs.length === 0 && !isLoading">
      <section class="section is-mono">
        <span class="tag is-rounded is-medium">
          <i class="fas fa-info fa-fw"></i>&nbsp;Sin certificados para mostrar
        </span>
      </section>
    </div>

    <paginator :resource="url" ref="paginator" @update="updateResource" :loading.sync="isLoading" />
  </section>
</template>
<script>
import Paginator from '@/components/utils/Paginator'
import LoadingSpin from '@/components/utils/LoadingSpin'
export default {
  components: {
    Paginator,
    LoadingSpin
  },
  data () {
    return {
      isLoading: false,
      certs: [],
      enabledOr: false,
      user: null,
      reasons: null,
      queryCertificates: {
        organizacionId: null,
        usuarioId: null,
        estados: null
      },
      paramsProcessed: ''
    }
  },
  beforeMount: function () {
    this.fetchReasons()
    this.getOrState(this.getUser.id)
    this.refresh()
  },
  methods: {
    setQuery (query) {
      this.isLoading = true
      this.queryCertificates.ordenamiento = query.order
      this.queryCertificates.organizacionId = query.selectedOrganizationId
      this.queryCertificates.usuarioId = query.selectedUserId
      this.queryCertificates.estados = query.selectedStates
      this.paramsProcessed = this.preprocessingParams()
    },
    refresh () {
      this.isLoading = true
      this.queryCertificates.ordenamiento = 'desc'
      this.queryCertificates.organizacionId = (this.tieneRolLyris) ? null : this.getOrganizacionId
      this.queryCertificates.usuarioId = null
      this.queryCertificates.estados = null
      this.paramsProcessed = this.preprocessingParams()
    },
    fetchReasons () {
      this.isLoading = true
      this.$http
        .get('/razon-revocacion')
        .then(res => {
          this.reasons = res.data
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            message: 'Ocurrió un error al recuperar los certificados',
            type: 'is-danger'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    preprocessingParams () {
      let params = ''

      params += '&direction=' + this.queryCertificates.ordenamiento

      if (this.queryCertificates.usuarioId != null) {
        params += '&usuario_id=' + this.queryCertificates.usuarioId
      }

      if (this.queryCertificates.organizacionId != null) {
        params += '&organizacion_id=' + this.queryCertificates.organizacionId
      }

      if (this.queryCertificates.estados != null) {
        let queryEstados = ''
        Object.keys(this.queryCertificates.estados).forEach(k => {
          var paramToLowerCase = this.queryCertificates.estados[k].toLowerCase()
          var paramCleaned = paramToLowerCase.replace('-', '')
          queryEstados ? queryEstados += `,${paramCleaned}` : queryEstados = `${paramCleaned}`
        })
        params += '&estados=' + queryEstados
      }

      this.isLoading = false
      return params
    },
    getOrState (userId) {
      this.isLoading = true
      this.$http
        .get(`/usuario/${userId}`)
        .then(res => {
          this.enabledOr = res.data.or_activo
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            message: 'Ocurrió un error al verificar el estado del Oficial de Registro',
            type: 'is-danger'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    aprobarCert (cert) {
      this.isLoading = true
      const request = {
        tipo: 'aprobacion',
        certificado_id: cert.id
      }
      this.$http
        .post('/acta-certificado', request)
        .then(() => {})
        .catch(() => {
          this.$buefy.snackbar.open({
            message: 'Ocurrió un error en la aprobación del certificado',
            type: 'is-danger'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    downloadActaAlta (docId) {
      this.isLoading = true
      this.$http
        .get(`/documento/${docId}/descarga`)
        .then(res => {
          this.isLoading = false
          window.location.href = res.data.link
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            message: 'Ha ocurrido un error con la descarga',
            type: 'is-danger'
          })
        })
    },
    updateResource (data) {
      this.certs = data
    },
    dateFormat (date) {
      return new Date(date).toLocaleDateString('fr')
    },
    reasonString (reason) {
      return `${reason.charAt(0).toUpperCase()}${reason.slice(1)}`
    }
  },
  watch: {
    certs: function (oldVal, newVal) {
      this.isLoading = true
      this.certs.forEach(cert => {
        if (cert.estado === 'revocado') {
          this.reasons.forEach(r => {
            if (r.id === cert.razon_revocacion) {
              this.razonRevocacion = r.mensaje
            }
          })
          cert.razon_revocacion = this.razonRevocacion
          this.razonRevocacion = ''
        }
      })
      this.isLoading = false
    }
  },
  computed: {
    getOrganizacionId () {
      return this.getUser.organization
    },
    tieneRolLyris () {
      return this.$store.getters.hasAnyRole(['lyris'])
    },
    getUser () {
      return this.$store.getters.getUser
    },
    url: function () {
      return '/certificado?sort=created_at' + this.paramsProcessed
    }
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  color: gray
}
</style>
